import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IAdministrator } from '@boma/supplier-portal/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class AdministratorsService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listAdminsitrators(supplierId: string, query: string = '') {
    return this.httpClient.get<IAdministrator[]>(
      `${this.base}api/v${this.version}/${supplierId}/Administrators`,
      {
        params: { query },
      }
    );
  }

  loadAdministratorDetails(supplierId: string, adminId: string) {
    return this.httpClient.get<IAdministrator>(
      `${this.base}api/v${this.version}/${supplierId}/Administrators/${adminId}`
    );
  }

  deleteAdministrator(supplierId: string, userId: string) {
    return this.httpClient.delete(
      `${this.base}api/v${this.version}/${supplierId}/Administrators/${userId}`
    );
  }

  createAdministrator(
    supplierId: string,
    emailAddressOrPhoneNumber: string,
    roleIds: string[]
  ) {
    return this.httpClient.post<IAdministrator>(
      `${this.base}api/v${this.version}/${supplierId}/Administrators`,
      {
        emailAddressOrPhoneNumber,
        roleIds,
      }
    );
  }

  updateAdministrator(supplierId: string, userId: string, roleIds: string[]) {
    return this.httpClient.put<IAdministrator>(
      `${this.base}api/v${this.version}/${supplierId}/Administrators/${userId}`,
      {
        roleIds,
      }
    );
  }
}
